module.exports = __webpack_public_path__ + "img/unauthorized.ce4f3c9c.jpg";